import { SurveyCreateShareComponent } from 'component'

export default () => {
    return (
        <SurveyCreateShareComponent/>
    )
}